module.exports = __webpack_public_path__ + "img/earnimg1.fad40d23.png";